module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00026.ca955cf2.png";